import React from 'react';
import PropTypes from 'prop-types';

const DurationRenderer = (props) => {
  const value = props.value;

  return (
    <span className="tw-text-blue-600">{value && value > 0 ? `${value} days` : ''}</span>
  );
};

DurationRenderer.propTypes = {
  value: PropTypes.number
};

export default DurationRenderer;
